import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';
import styles from './couples-item.module.scss';
import { Avatar, Typography } from '@/ui-kit';
import { generatePath, Link } from 'react-router-dom';
import { routesApp } from '@/constans/routes';
import { ClockIcon } from '@/assets/icons';
import { differenceInDays, differenceInHours } from 'date-fns';
import { useTranslation } from 'react-i18next';

interface Props {
    className?: string;
    ellipse?: boolean;
    info?: string | null;
    avatar?: string | null;
    href?: string;
    isOnline?: boolean;
    expiredAt?: string | null;
    onClick?: () => void;
}

export const CouplesItem: React.FC<PropsWithChildren<Props>> = ({
    className,
    ellipse,
    info,
    avatar,
    children,
    href,
    isOnline = false,
    expiredAt = null,
    onClick,
}) => {
    const expiredIconSize = 11.2

    const { t } = useTranslation();

    return (
        <Link
            to={href ?? '#'}
            className={clsx(className, styles.coupleItem)}
            onClick={onClick}>
            <div className={
                clsx(
                    styles.avatar,
                    ellipse && styles.ellipse,
                    (
                        isOnline &&
                        !expiredAt
                    ) && styles['avatar--online'],
                    expiredAt && styles['avatar--expired'],
                )
            }>
                <Avatar src={avatar} alt="avatar" />
                {
                    expiredAt &&
                    <div className={styles.expiredChipMask}>
                        <div className={styles.expiredChip}>
                            <ClockIcon
                                width={expiredIconSize}
                                height={expiredIconSize}
                                className={styles.expiredChipIcon} />
                            <Typography
                                variant="span"
                                typeColor="white"
                                fontWeight="semibold"
                                className={styles.expiredChipLabel}>
                                {
                                    differenceInDays(expiredAt, new Date()) > 0 ?
                                        differenceInDays(expiredAt, new Date())
                                    : differenceInHours(expiredAt, new Date()) > 0 ?
                                        differenceInHours(expiredAt, new Date())
                                    : '<1'
                                }
                                {
                                    differenceInDays(expiredAt, new Date()) > 0 ?
                                        t('msgs.day_short_unit')
                                    :
                                        t('msgs.hour_short_unit')
                                }
                            </Typography>
                        </div>
                    </div>
                }
                {children}
            </div>
            {info && (
                <Typography
                    typeColor="brown"
                    className={styles.info}
                    fontWeight="bold"
                    center>
                    {info}
                </Typography>
            )}
        </Link>
    );
};
